import { FilterAlt } from '@mui/icons-material'
import { styled } from '@mui/material'

export const Filter = styled(FilterAlt)(({ theme }) => ({
  '&[data-active="true"]': {
    color: `${theme.palette.primary.main} !important`,
  },
}))
